import React from "react";
import StaticPage from "../components/StaticPage";

export default function HowItWorks() {
    return (
        <StaticPage
            kicker="How it works"
            title="From master file to new owner — in six clean steps."
            lede="No middlemen, no renewal fees. A transparent legal and financial workflow built for cinema, under Indian copyright law."
            blocks={[
                { eyebrow: "Step 1", title: "Creator uploads",
                  body: "Filmmaker submits poster, trailer, master and full metadata through the Upload Studio." },
                { eyebrow: "Step 2", title: "Assignment deed signed",
                  body: "Creator signs a Section 18 deed assigning copyright to Silver Screen Xchange for onward transfer." },
                { eyebrow: "Step 3", title: "Legal review",
                  body: "Chain-of-title audit, warranties review, clearances verified — then the film is listed." },
                { eyebrow: "Step 4", title: "Buyer acquires",
                  body: "Verified buyer opens a Deal Room, signs the Purchase Agreement, and pays into escrow." },
                { eyebrow: "Step 5", title: "Payment captured",
                  body: "Funds release to the creator. Transfer Record is issued to the buyer." },
                { eyebrow: "Step 6", title: "Vault unlocks",
                  body: "Buyer downloads the master and receives the chain-of-title archive and proof of ownership." },
            ]}
            cta={{ label: "Browse the marketplace", href: "/catalog" }}
        />
    );
}
